// @ts-ignore
import React, {useEffect} from "react";
import {Helmet} from "react-helmet";
import "./src/sass/app.scss";
import "@govflanders/vl-ui-core";
import {FlandersScriptProvider} from "./src/contexts/flanders";

export const wrapPageElement = ({element}) => {
  useEffect(() => {
    const headerContainerDiv = document.getElementById('VlaamseHeader');
    const headerScriptElement = document.createElement('script');
    headerScriptElement.src = process.env.GATSBY_FLANDERS_HEADER;
    headerContainerDiv.appendChild(headerScriptElement);

    const footerContainerDiv = document.getElementById('VlaamseFooter');
    const footerScriptElement = document.createElement('script');
    footerScriptElement.src = process.env.GATSBY_FLANDERS_FOOTER;
    footerContainerDiv.appendChild(footerScriptElement);
  }, []);

  return (
    <>
      <FlandersScriptProvider
        clientScriptSource={process.env.GATSBY_FLANDERS_HEAD_INCLUDE_CLIENT}
        polyfillScriptSource={process.env.GATSBY_FLANDERS_HEAD_INCLUDE_POLYFILL}
      >
        <Helmet htmlAttributes={{lang: "nl"}}>
          <link
            key="gatsby-plugin-plausible-preconnect"
            rel="preconnect"
            href="https://plausible.lblod.info"
          />
          <script
            data-domain={process.env.GATSBY_PLAUSIBLE_DOMAIN}
            src="https://plausible.lblod.info/js/script.file-downloads.js"
            async
            defer
          />
        </Helmet>
        <main>{element}</main>
      </FlandersScriptProvider>
    </>
  );
}

export const shouldUpdateScroll = ({routerProps}) => {
  try {
    const {disableScrollUpdate} = routerProps?.location?.state;
    return !disableScrollUpdate;
  } catch (e) {
    return false;
  }
};

export const onRouteUpdate = ({location}): void => {
  if (location.hash) {
    const id: string = location.hash.substring(1);
    const element: HTMLElement = document.getElementById(id);
    if (element) element.scrollIntoView();
  }
};
